import React from 'react'
import './scubahero.scss';

const ScubaHero = () => {
    return (
        
            <article className="container-fluid">
                <section className="row">
                    <div className="col px-0">

                    <div className="scuba-bg">

                        <h2 className="hero-text">The best way to observe a fish is to become a fish. <br /> <span className="quote-text"> Jacques Cousteau </span></h2>
                        
                    </div>

                    </div>
                </section>
            </article>
        
    )
}

export default ScubaHero
